module.exports = __webpack_public_path__ + "static/img/ku-ipp.dc06406.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/ku-ipp.jpg
// module id = JdiU
// module chunks = 0